{
  "familyId": "SWW-VT-DUBBEL",
  "questions": [
    {
      "id": "SWW-VT-DUBBEL-001",
      "familyId": "SWW-VT-DUBBEL",
      "module": "SpellingWW",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_dubbel_dt",
      "questionType": "multiple_choice",
      "question": "De leerlingen ... hard voor de toets. (werken, verleden tijd meervoud)",
      "context": null,
      "options": ["werkten", "werkte", "werktten", "gewerkt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Dubbele Letters", "content": "Als de stam al eindigt op -t, krijg je dubbele t: werk + te = werkte, werk + ten = werkten (niet werktten!).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "complex_verb_forms_plural_past",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: kofschip-regel met dubbele letters. Stap 1: De stam van 'werken' is 'werk'. Stap 2: De laatste letter 'k' zit in 't kofschip → dus -te(n). Stap 3: 'De leerlingen' is meervoud → werk + ten = werkten. Let op: NIET werktten (geen dubbele t bij meervoud). Checkstrategie: tel de letters — stam + ten = één t, niet twee.",
        "distractorExplanations": {
          "0": "Correct! Kofschip-regel: 'k' in kofschip → werk + ten = werkten (meervoud).",
          "1": "Veelgemaakte fout: enkelvoud gebruiken bij meervoud onderwerp. 'Werkte' is enkelvoud (hij/zij werkte). 'De leerlingen' is meervoud, dus -ten: werkten. Misconceptie: enkelvoud en meervoud verwarren.",
          "2": "Veelgemaakte fout: een extra t toevoegen. 'Werktten' heeft een dubbele t te veel. De regel is: stam + ten = werkten (niet werk + tten). Misconceptie: denken dat de t van de stam en de t van -ten apart geschreven worden.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Gewerkt' hoort bij 'hebben gewerkt'. Hier is geen hulpwerkwoord, dus gewoon verleden tijd: werkten."
        }
      }
    }
  ]
}